import { UpdatePatientContact } from 'domain/usecases/patient/update-patient-contact'
import { PatientNewRepository } from 'repository/interfaces/patient-new-repository'

export class RemoteUpdatePatientContact implements UpdatePatientContact {
  private readonly patientNewRepository: PatientNewRepository

  constructor(patientNewRepository: PatientNewRepository) {
    this.patientNewRepository = patientNewRepository
  }

  update(
    params: UpdatePatientContact.Params
  ): Promise<UpdatePatientContact.Model> {
    return this.patientNewRepository.updatePatientContact(params)
  }
}
